import { Controller } from "@hotwired/stimulus";

export default class DocumentsSearchController extends Controller {
  static targets = ["input", "clearButton", "uploadedRow"];

  filter() {
    const term = this.inputTarget.value.toLowerCase().trim();

    this.clearButtonTarget.classList.toggle("!hidden", term.length === 0);

    this.uploadedRowTargets.forEach((row) => {
      const text = row.dataset.searchText ?? "";
      row.classList.toggle("!hidden", term.length > 0 && !text.includes(term));
    });
  }

  clear() {
    this.inputTarget.value = "";
    this.filter();
    this.inputTarget.focus();
  }

  focusInput() {
    this.inputTarget.focus();
  }
}
